import { __awaiter, __generator } from "tslib";
import { fetchEncryptionKey } from '@office-start/identity-service';
import { createSimpleStaleWhileRevalidateOperation, } from '@office-start/persistence-strategies';
import { createEncryptionPlugin, readFromSimplePersistence, writeToSimplePersistence, } from '@office-start/simple-persistence';
import { getWorkspaces } from './operations/getWorkspaces';
var workspacesPersistenceKey = 'workspaces-api';
var workspacesPersistenceVersion = 1;
export function executeWorkspacesDataFlow(identity, officeComponentContext, appGalleryConfig, handleRevalidation) {
    return __awaiter(this, void 0, void 0, function () {
        var options, encryptionKey, plugins;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    options = {
                        correlationId: officeComponentContext.correlationId,
                        getAccessToken: officeComponentContext.getAccessToken,
                        inMockMode: officeComponentContext.inMockMode,
                        jwtAuthEnabled: officeComponentContext.jwtAuthEnabled,
                        officeHomeApiRoot: officeComponentContext.officeHomeApiRoot,
                        myApplicationsUrl: appGalleryConfig.myApplicationsUrl,
                        tenantId: identity.tenantId,
                        userId: identity.objectId,
                        dataBoundary: identity.dataBoundary,
                        tenantRegionScope: identity.tenantRegionScope || '',
                        acceptLanguage: officeComponentContext.preferredCulture,
                    };
                    return [4 /*yield*/, fetchEncryptionKey()];
                case 1:
                    encryptionKey = _a.sent();
                    plugins = (encryptionKey === null || encryptionKey === void 0 ? void 0 : encryptionKey.key)
                        ? [createEncryptionPlugin(encryptionKey.key)]
                        : [];
                    return [2 /*return*/, createSimpleStaleWhileRevalidateOperation(function () { return getWorkspaces(options, "network-only" /* FetchStrategy.NetworkOnly */); }, function () {
                            return readFromSimplePersistence({
                                userId: identity.puid,
                                collectionName: workspacesPersistenceKey,
                                collectionVersion: workspacesPersistenceVersion,
                                key: workspacesPersistenceKey,
                                plugins: plugins,
                            });
                        }, function (networkPayload) {
                            return writeToSimplePersistence({
                                userId: identity.puid,
                                collectionName: workspacesPersistenceKey,
                                collectionVersion: workspacesPersistenceVersion,
                                key: workspacesPersistenceKey,
                                data: networkPayload,
                                plugins: plugins,
                            });
                        }, handleRevalidation)];
            }
        });
    });
}
//# sourceMappingURL=executeWorkspacesDataFlow.js.map